import { Box, Center, Flex, Input, InputGroup, InputLeftAddon, Spinner, Text } from '@chakra-ui/react'
import Header from '../../../components/Header'
import { HeadingPages } from '../../../components/HeadingPages'
import { IoImagesOutline } from 'react-icons/io5'
import { FaShareAltSquare } from 'react-icons/fa'
import { useEffect, useMemo, useState } from 'react'
import { ModalNewProduct } from './components/ModalNewProduct'
import Axios from 'axios'

import { ModalProduct } from './components/ModalProduct'
import { Pagination } from './components/Pagination'
import { useDebounce } from '../../../hooks/useDebounce'
import { useQuery } from 'react-query'
import { DeleteImage } from './components/DeleteImage'

export function UploadImageProductSite() {
  const [selectedField, setSelectedField] = useState('innovationBrindes')
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const debouncedSearchTerm = useDebounce(search, 500)

  const type = selectedField === 'innovationBrindes' ? 2 : 1

  const { data, isLoading } = useQuery(
    ['images-upload-production', type, debouncedSearchTerm, page],
    () => Axios.get(`${process.env.REACT_APP_BASE_URL}/site/v2/fluxo-imagem/listar-diretorio-imagens/${type}/${debouncedSearchTerm}?page=${page}`),
    {
      keepPreviousData: true,
      staleTime: 60 * 60 * 1000,
    }
  )

  const totalPages = data?.data?.last_page

  function nextPage() {
    setPage(page + 1)
  }

  function prevPage() {
    setPage(page - 1)
  }

  useEffect(() => {
    setPage(1)
  }, [selectedField])

  const label = selectedField === 'innovationBrindes' ? 'Innovation Brindes' : 'Innovation Store'

  return (
    <>
      <HeadingPages name={`Upload - Imagens - ${label}`} />

      <Flex maxW={1480} mx="auto" w="100%" my="6" px="6" flexDir="column">
        <Flex gap={5} h="calc(100vh - 80px - 160px)" flexDir="column">
          <Flex justifyContent="flex-start" alignItems="center" w="100%" gap={6}>
            <Flex bgColor="#fff" w="500px" borderRadius="md" boxShadow="0 0 3px rgba(0,0,0,.1)" flexDir="column" alignItems="flex-start">
              <Flex mb="1rem" w="100%" p={2} flexDir="column" gap={2}>
                <ModalNewProduct selectedField={selectedField} />
                <DeleteImage selectedField={selectedField} />
              </Flex>
              <Box
                w="100%"
                bgColor={selectedField === 'innovationBrindes' ? '#e5e5e5' : '#f5f5f5'}
                px="1rem"
                py="0.5rem"
                _hover={{
                  cursor: 'pointer',
                  bgColor: '#e5e5e5',
                }}
                onClick={() => setSelectedField('innovationBrindes')}
              >
                <Flex gap={2} align="center">
                  <IoImagesOutline size={20} />

                  <Text>Innovation Brindes</Text>
                </Flex>
              </Box>
              <Box
                w="100%"
                bgColor={selectedField === 'innovationStore' ? '#e5e5e5' : '#f5f5f5'}
                px="1rem"
                py="0.5rem"
                _hover={{
                  cursor: 'pointer',
                  bgColor: '#e5e5e5',
                }}
                onClick={() => setSelectedField('innovationStore')}
              >
                <Flex gap={2} align="center">
                  <FaShareAltSquare size={20} />
                  <Text>Innovation Store</Text>
                </Flex>
              </Box>
            </Flex>
            <Flex bgColor="#fff" flex={1} borderRadius="md" boxShadow="0 0 3px rgba(0,0,0,.1)" flexDir="column" alignItems="center" height={'100%'}>
              <Flex flexDir="column" maxWidth="400px" p="1rem" gap={2} height={'100%'}>
                <Text as="h1" fontSize="1.2rem" fontWeight="bold" color="gray.700" textAlign="center">
                  Pesquise por código do produto
                </Text>
                <InputGroup>
                  <InputLeftAddon children="Cod. prod." />
                  <Input placeholder="Pesquisar..." onChange={(e) => setSearch(e.target.value)} />
                </InputGroup>
              </Flex>
            </Flex>
          </Flex>
          <Flex
            flex={1}
            gap={5}
            borderRadius="md"
            boxShadow="0 0 3px rgba(0,0,0,.1)"
            alignItems="flex-start"
            justifyContent="flex-start"
            bgColor="#fff"
            w="100%"
            overflowY="auto"
            padding="1rem"
            flexWrap="wrap"
            position="relative"
            css={{
              '&::-webkit-scrollbar': {
                width: '4px',
                height: '4px',
              },
              '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#888',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
              },
            }}
          >
            {isLoading && (
              <Center position="absolute" top="50%" left="50%" transform="translate(-50%, -50%)">
                <Spinner thickness="4px" speed="0.65s" size="lg" />
              </Center>
            )}
            {!isLoading && data?.data?.length === 0 && (
              <Flex flexDir="column" alignItems="center" justifyContent="center" w="100%" h="100%">
                <Text as="h1" fontSize="1.2rem" fontWeight="bold" color="gray.700" textAlign="center">
                  Nenhum resultado encontrado
                </Text>
              </Flex>
            )}

            {!isLoading && data?.data?.data?.map((item, index) => <ModalProduct selectedField={selectedField} item={item} key={index} />)}
          </Flex>
          <Flex w="100%" justifyContent="center" bg="#fff" boxShadow="0 0 3px rgba(0,0,0,.1)" padding=".4rem">
            <Pagination nextPage={nextPage} prevPage={prevPage} setPage={setPage} page={page} totalPages={totalPages} />
          </Flex>
        </Flex>
      </Flex>
    </>
  )
}
